import { SVGFC } from '@repo/toolkit/types'

const UserTwoIcon: SVGFC = ({ color = 'white', fill = 'none', ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.0006 12.0002C13.3261 12.0002 14.4006 10.9257 14.4006 9.60019C14.4006 8.27471 13.3261 7.2002 12.0006 7.2002C10.6751 7.2002 9.60059 8.27471 9.60059 9.60019C9.60059 10.9257 10.6751 12.0002 12.0006 12.0002Z"
        stroke={color}
        strokeWidth="1.24445"
      />
      <path
        d="M16.7776 18.4004C16.6496 16.0868 15.9416 14.4004 12.0016 14.4004C8.06159 14.4004 7.35359 16.0868 7.22559 18.4004"
        stroke={color}
        strokeWidth="1.24445"
        strokeLinecap="round"
      />
      <path
        d="M8 5.07041C9.21562 4.36713 10.5956 3.99785 12 4.00001C16.4184 4.00001 20 7.58161 20 12C20 16.4184 16.4184 20 12 20C7.5816 20 4 16.4184 4 12C4 10.5432 4.3896 9.17601 5.0704 8.00001"
        stroke={color}
        strokeWidth="1.24445"
        strokeLinecap="round"
      />
    </svg>
  )
}

export default UserTwoIcon
